import { connect } from 'react-redux';
import ClientMenuView from './ClientMenuView';
import * as actions from './ClientMenuActions';
import { isCurrentPlanSelector } from '../../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { resetFinancialPlan } from '../../../FinancialPlan/FinancialPlanActions';
import resetWhatIfs from '../../../WhatIfs/WhatIfsController';
import { currentClientSelector } from '../../../CommonSelectors/CommonAreaSelector';
import {
  canChangeOwnerSelector,
  canShareConsumersSelector,
} from '../../../SharingSettings/SharingSettingsSelector';
import * as selectors from './ClientMenuSelector';
import {
  canInviteConsumerSelector,
  selectIsOrionAdviser,
  selectHasGliaCobrowse,
  showFinancialPlanningSelector,
} from '../../../AdviserArea/AdviserAreaSelector';

const mapStateToProps = state => {
  const client = currentClientSelector(state);

  return {
    client,
    isCurrentPlan: isCurrentPlanSelector(state, { clientId: client.Id }),
    isDeleteClientEnabled: ADV.entities.isOptedIn('DeleteClient'),
    deleteActionLabel: client && client.CanDeleteConsumer ? 'Delete Client' : 'Remove Client',
    sharingCanChangeOwner: canShareConsumersSelector(state),
    sharingCanChangeConsumer: canChangeOwnerSelector(state),
    isSharingSettingsModalOpen: selectors.isSharingSettingsModalOpenSelector(state),
    modalErrors: selectors.modalErrorsSelector(state),
    canInviteConsumer: canInviteConsumerSelector(state),
    isOnlineGlia: selectors.selectIsOnlineGlia(state),
    showGliaStatus: selectHasGliaCobrowse(state) && selectIsOrionAdviser(state),
    showFinancialPlanning: showFinancialPlanningSelector(state),
  };
};

const mapDispatchToProps = dispatch => ({
  setModalErrors(errors) {
    dispatch(actions.setModalErrors(errors));
  },
  openSharingSettingsModal() {
    dispatch(actions.setIsVisibleSharingSettingsModal(true));
  },
  closeSharingSettingsModal() {
    dispatch(actions.setIsVisibleSharingSettingsModal(false));
  },
  downloadPdf(clientId) {
    ADV.util.Router.go2('AdvancedPDF', {
      clientId,
    });
  },
  resetPlan(clientId) {
    const warningMessage = ADV.settings.MsgLib.FinancialPlan.notice_changed_settings_warning;

    const buttons = [
      {
        label: 'Reset',
        classes: 'red',
      },
      {
        label: 'Cancel',
        classes: 'dismiss secondary',
      },
    ];

    ADV.util.popup.confirm(warningMessage, buttons, choice => {
      if (choice === 0) {
        const refresh = ADV.NewFinancialPlan;
        dispatch(
          resetFinancialPlan(clientId, params => {
            if (refresh) {
              refresh.refreshPlan(params);
            }
            resetWhatIfs(clientId);
          }),
        );
      }
    });
  },
  viewClientActivity(clientId) {
    ADV.util.Router.go2('UserActivity', { clientId });
  },
  viewClientSettings(clientId) {
    ADV.util.Router.go2('ClientSettings', {
      clientId,
    });
  },
  getGliaOnlineStatus(clientId) {
    dispatch(actions.getGliaOnlineStatus(clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientMenuView);
